import React, { FC, useContext } from 'react';
import { analyticService } from 'global/services';
import { DishesSelectionContext } from 'app/containers/contexts/dishesSelection.context';
import { selectionRecord } from 'app/components/banners/MenuSelectionsMobileSlider/selections.record';
import { gql, useFragment, useReactiveVar } from '@apollo/client';
import { isGlobalLoadingVar, selectedPeriodVar } from 'app/apollo/reaction';
import css from './BasketUpsellSelections.module.scss';

import BasketUpsellSelectionsCard from '../BasketUpsellSelectionsCard';
import { ISelection } from '../../types';
import { useDynamicUpsellSelections } from './useDynamicUpsellSelections';

const BasketUpsellSelections: FC<any> = ({
    setName,
    executeNeccessaryCartSaving = null,
}: any) => {
    const { onOpenSelection } = useContext<any>(DishesSelectionContext);
    const isGlobalLoading = useReactiveVar(isGlobalLoadingVar);

    const selectedPeriod = selectedPeriodVar();
    const upsellSelections = useDynamicUpsellSelections(setName);

    const { data } = useFragment({
        fragment: gql`
            fragment CHECK_AHMAD_DISHES on cart {
                type
                period
                sections {
                    id
                    items {
                        dish_id
                    }
                    cartType
                }
            }
        `,
        from: {
            __ref: `cart:new:${selectedPeriod}`,
        },
    }) || { data: { sections: [] } };

    return (
        <div className={css.basketUpsellSelectionsRoot}>
            <div className={css.basketUpsellSelectionsWrapper}>
                {upsellSelections.map((selection: ISelection) => {
                    const targetSelection = selectionRecord.find((record) => record.id === selection.id);
                    const targetType = targetSelection?.type;
                    const onClickHandler = () => {
                        if (isGlobalLoading) return;
                        analyticService.push({
                            eventName: 'Upsell_Click',
                            upsell_type: 'something_special',
                            banner_name: selection.selectionTag,
                            source_name: 'basket',
                        });
                        if (selection.type === 'link') {
                            // @ts-ignore
                            window.location = `${selection.href}?period=${selectedPeriodVar()}` || '/';
                            return;
                        }
                        onOpenSelection({ tag: targetSelection?.tag || selection.selectionTag, targetRealm: 'new_upsell' });
                    };

                    const isCartSavingChecksNeeded = executeNeccessaryCartSaving && selection.type === 'link';

                    return (
                        <BasketUpsellSelectionsCard
                            key={selection.id}
                            title={selection.title}
                            iconPath={selection.iconPath}
                            // @ts-ignore
                            onClickHandler={
                                isCartSavingChecksNeeded
                                    ? (e: any) => executeNeccessaryCartSaving(e,
                                        { deliverySavingPopupText: selection?.savingDeliveryСartText },
                                        onClickHandler)
                                    : onClickHandler
                            }
                        />
                    );
                })}
            </div>
        </div>
    );
};

export default BasketUpsellSelections;
